import { createDailyEventsFromExternalEvents } from '@griply/utils';
import { addDays, endOfDay, isBefore, startOfDay } from 'date-fns';
import { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';
import { useExternalCalendarEventsQuery } from 'shared/hooks/queries/use-external-calendar-events-query';

export const useUpcomingExternalCalendarEvents = () => {
  const today = useToday();
  const endDate = useMemo(() => addDays(endOfDay(today), 9), [today]);
  const { data } = useExternalCalendarEventsQuery(
    startOfDay(today).toISOString(),
    endDate.toISOString(),
    Intl.DateTimeFormat().resolvedOptions().timeZone,
  );

  return useMemo(
    () =>
      data?.length
        ? createDailyEventsFromExternalEvents(data)
            // filter out the events that are further than the 9 days ahead.
            // This is possible for multi-day events that start before but surpass the endDate
            .filter(({ start }) =>
              isBefore(start.dateTime ?? start.date, endDate),
            )
        : [],
    [data, endDate],
  );
};
